import React from 'react';

import styles from './ThreeColumnRank.module.less';
import GameLink from '../GameLink';
import Icon from '../Icon';
import Button from '../Button';
import generateURL from '../../generateURL';

export default ({ tag, ranks = [] }) => {
  ranks = ranks.slice(0, 3);

  return (
    <div className={styles.ThreeColumnRank}>
      {
        ranks
          .map(rank => {
            let source = `${tag}||${rank.code || ''}`;
            let to = generateURL(rank);
            return (
              <section key={rank.code}>
                <header>{rank.name || rank.desc}<GameLink source={source} to={to} logInfo={{
                  category: 'C',
                  action: 'Game_New_More',
                  params: {
                    source,
                  }
                }}>更多</GameLink></header>
                <nav>
                  {
                    rank
                      .apps
                      .slice(0, 5)
                      .map((app, appIndex) => {
                        let id = app.softID || ''
                        if (app.androidType === '1') {
                          id = app.packageName
                        }
        
                        return (
                          <GameLink
                            key={appIndex}
                            info={{
                              targetType: '1',
                              appInfo: app,
                            }}
                            source={source}
                            logInfo={{
                              category: 'C',
                              action: 'Game_Non_Button',
                              params: {
                                id,
                                type: 'soft',
                                source,
                              },
                              bizInfo: app.bizInfo,
                            }}>
                            <Icon className={styles.icon} app={app} />
                            <main>
                              <h1 title={app.softName}>{app.softName}</h1>
                              {new Array(Math.floor((app.score || 0) / 20) + 2)
                                .join(' ')
                                .split('')
                                .slice(0, 5)
                                .map((o, index) => <i key={index} />)}
                              <p>{app.downloadCount || '1万次'}下载</p>
                              <Button
                                soft={app}
                                className="action btn"
                                logInfo={{source}} />
                            </main>
                          </GameLink>
                        )
                      })
                  }
                </nav>
              </section>
            )
          })
      }
    </div>
  );
};
